import { render, staticRenderFns } from "./confirmationV2.vue?vue&type=template&id=961d7e3e&scoped=true&"
import script from "./confirmationV2.vue?vue&type=script&lang=js&"
export * from "./confirmationV2.vue?vue&type=script&lang=js&"
import style0 from "./confirmationV2.vue?vue&type=style&index=0&id=961d7e3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961d7e3e",
  null
  
)

export default component.exports